export const store = {
  searchData:[],
  searchedTerm:'',  
  state: {
    lastExplore: '',
    lastTab: null,
    showModal: '',
    showTopBtn: false,
    showMenu: false
  },
  toggleModal(id = '') {
    /*
      If id is the same as modal already opened, then close existing modal. Otherwise open modal with id.
    */
    if (id === this.state.showModal) {
      this.state.showModal = '';
    } else {
      this.state.showModal = id;
    }
  },
  toggleMenu() {
    this.state.showMenu = !this.state.showMenu;
  },
  updateLastExplore(id) {
    this.state.lastExplore = id;
  },
  updateLastTab(id = null) {
    this.state.lastTab = id;
  }
};

export { store as default };
